























































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Barcode from "../../components/bar-code.vue";
import { mixins } from "vue-class-component";
import _ from "lodash";
import DateTimeMixin from "@/components/mixin/date-time-mixin";
import SerialListModal from "../../components/view-serials-paging.vue";
import SerialInfo from "@/store/entities/products/serial-info";

class PageReturnOrderLineRequest extends PageRequest {
  keyword: string;
  id: number;
}
class PageReturnOrderReceiptRequest extends PageRequest {
  keyword: string;
  fromDate: Date;
  toDate: Date;
  id: number;
}

@Component({
  components: {
    "bar-code": Barcode,
    "serial-modal": SerialListModal,
  },
})
export default class ViewReturnOrder extends mixins(DateTimeMixin, AbpBase) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  namespace = "returnOrder";
  linePageRequest: PageReturnOrderLineRequest = new PageReturnOrderLineRequest();
  receiptPageRequest: PageReturnOrderReceiptRequest = new PageReturnOrderReceiptRequest();
  returnOrder: any;
  serialModalShow: boolean = false;
  serialInfo = new SerialInfo();

  spinShow: boolean = false;
  code: string = "";
  id: number = 0;
  creationTime: Date[] = [];

  get store() {
    return this.$store.state.returnOrder;
  }
  get returnOrderCode() {
    return this.code;
  }

  isTenant() {
    return this.$store.state.session.tenant != null;
  }
  openSerialModal() {
    this.serialModalShow = true;
  }
  closeSerialModal() {
    this.serialModalShow = false;
    this.serialInfo = new SerialInfo();
  }
  showDetail(row, fieldName: string) {
    this.serialInfo.productName = row.productName;
    this.serialInfo.productId = row.productId;
    if (fieldName === "handoverQty") {
      this.serialInfo.qty = row.handoverQty;
      this.serialInfo.serials = _.map(row.handoverSerials, function(item) {
        var serial = {
          serialNo: item,
        };
        return serial;
      });
    } else {
      this.serialInfo.qty = row.receivedQty;
      this.serialInfo.serials = _.map(row.receivedSerials, function(item) {
        var serial = {
          serialNo: item,
        };
        return serial;
      });
    }
    this.openSerialModal();
  }
  //============Receipt page =================
  get receiptLoading() {
    return this.store.receiptLoading;
  }
  preGetReceiptPage() {
    this.receiptPageRequest.maxResultCount = this.receiptPageSize;
    this.receiptPageRequest.skipCount =
      (this.receiptCurrentPage - 1) * this.receiptPageSize;
    this.receiptPageRequest.id = this.id;
    if (this.creationTime.length > 0) {
      this.receiptPageRequest.fromDate = this.creationTime[0];
    }
    if (this.creationTime.length > 1) {
      this.receiptPageRequest.toDate = this.creationTime[1];
    }
  }
  get receiptList() {
    var re = this.store.receiptList;
    var startIndex = (this.receiptCurrentPage - 1) * this.receiptPageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }

  get receiptPageSize() {
    return this.store.receiptPageSize;
  }
  get receiptTotalCount() {
    return this.store.receiptTotalCount;
  }
  get receiptCurrentPage() {
    return this.store.receiptCurrentPage;
  }
  refreshReceiptPageIndex() {
    this.$store.commit(`${this.namespace}/setReceiptCurrentPage`, 1);
  }
  receiptPageChange(page: number) {
    this.$store.commit(`${this.namespace}/setReceiptCurrentPage`, page);
    this.getReceiptPage();
  }
  receiptPageSizeChange(pagesize: number) {
    this.$store.commit(`${this.namespace}/setReceiptPageSize`, pagesize);
    this.getReceiptPage();
  }
  async searchReceiptData() {
    this.refreshReceiptPageIndex();
    await this.getReceiptPage();
  }
  async getReceiptPage() {
    this.preGetReceiptPage();
    await this.$store
      .dispatch({
        type: `${this.namespace}/getAllReceipts`,
        data: this.receiptPageRequest,
      })
      .catch(() => {
        this.store.receiptLoading = false;
      });
  }
  //============line page =================
  get sumQty() {
    return _.isNil(this.lineList) || this.lineList.length <= 0
      ? 0
      : this.lineList[0].sumQty;
  }
  get sumHandoverQty() {
    return _.isNil(this.lineList) || this.lineList.length <= 0
      ? 0
      : this.lineList[0].sumHandoverQty;
  }
  get sumReceivedQty() {
    return _.isNil(this.lineList) || this.lineList.length <= 0
      ? 0
      : this.lineList[0].sumReceivedQty;
  }
  get lineLoading() {
    return this.store.lineLoading;
  }
  get linePageSize() {
    return this.store.linePageSize;
  }
  get lineTotalCount() {
    return this.store.lineTotalCount;
  }
  get lineCurrentPage() {
    return this.store.lineCurrentPage;
  }
  preGetLinePage() {
    this.linePageRequest.id = this.id;
    this.linePageRequest.maxResultCount = this.linePageSize;
    this.linePageRequest.skipCount =
      (this.lineCurrentPage - 1) * this.linePageSize;
  }
  refreshLinePageIndex() {
    this.$store.commit(`${this.namespace}/setLineCurrentPage`, 1);
  }
  linePageChange(page: number) {
    this.$store.commit(`${this.namespace}/setLineCurrentPage`, page);
    this.getLinePage();
  }
  linePageSizeChange(pagesize: number) {
    this.$store.commit(`${this.namespace}/setLinePageSize`, pagesize);
    this.getLinePage();
  }
  async searchLineData() {
    this.refreshLinePageIndex();
    await this.getLinePage();
  }
  async getLinePage() {
    this.preGetLinePage();
    await this.$store
      .dispatch({
        type: `${this.namespace}/getAllLines`,
        data: this.linePageRequest,
      })
      .catch(() => {
        this.store.lineLoading = false;
      });
  }
  get lineList() {
    var re = this.store.lineList;
    var startIndex = (this.lineCurrentPage - 1) * this.linePageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }

  //======== functions ===========
  cancel() {
    this.$emit("input", false);
    this.$root.$router.push({ name: "returnOrder" });
  }
  async getReturnOrder() {
    await this.$store
      .dispatch({
        type: "returnOrder/get",
        data: { id: this.id },
      })
      .then(async (result) => {
        this.returnOrder = result;
        this.id = this.returnOrder.id;
        this.code = this.returnOrder.code;
        this.getLinePage();
        this.getReceiptPage();
      });
  }

  async created() {
    this.spinShow = true;
    try {
      this.id = +this.$root.$router.currentRoute.params.id;
      await this.getReturnOrder();
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }

  receiptColumns = [
    {
      title: Util.L("Order"),
      key: "orderNo",
      width: 50,
    },
    {
      title: Util.L("ReturnOrderReceiptCode"),
      width: 150,
      key: "code",
    },
    {
      title: Util.L("CreatorUserName"),
      render: (h: any, params: any) => {
        if (_.isNil(params.row.creatorUser)) return "";
        return h(
          "span",
          `${params.row.creatorUser.userName} - ${params.row.creatorUser.name}`
        );
      },
    },
    {
      title: Util.L("CreationTime"),
      width: 200,
      key: "creationTime",
      render: (h: any, params: any) => {
        return h("span", Util.toViewDateString(params.row.creationTime));
      },
    },
    {
      title: Util.L("Action"),
      width: 100,
      fixed: "right",
      slot: "action",
      align: "center",
    },
  ];
  renderWarehouseColumn() {
    if (this.isTenant()) {
      return [];
    }
    return [
      {
        title: Util.L("Warehouse"),
        width: 170,
        key: "warehouseCode",
        render: (h: any, params: any) => {
          return h(
            "span",
            `${params.row.warehouseCode} - ${params.row.warehouseName}`
          );
        },
      },
    ];
  }
  get lineColumns() {
    return [
      {
        title: Util.L("Order"),
        key: "orderNo",
        width: 50,
      },
      ...this.renderWarehouseColumn(),
      {
        title: Util.L("Sku"),
        width: 150,
        key: "sku",
      },
      {
        title: Util.L("ProductName"),
        width: 250,
        key: "productName",
      },
      {
        title: Util.L("ExportBrandName"),
        width: 200,
        key: "exportBrandName",
      },
      {
        title: Util.L("Unit"),
        width: 100,
        key: "unitName",
      },

      {
        title: Util.L("OrderType"),
        width: 150,
        key: "orderTypeName",
      },
      {
        title: `${Util.L("ReturnedQty")} (${this.sumQty})`,
        key: "qty",
        width: 120,
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.qty));
        },
      },
      {
        title: `${Util.L("ReturnHandoverQty")} (${this.sumHandoverQty})`,
        width: 120,
        align: "right",
        slot: "handoverQty",
      },
      {
        title: `${Util.L("ReceivedQty")} (${this.sumReceivedQty})`,
        slot: "receivedQty",
        width: 120,
        align: "right",
      },
    ];
  }
}
